import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const BalanceValuePrimaryDefaultBox = styled.span`
    font-size: 2rem;
    font-weight: 700;
    color: ${({theme}) => theme.colors.moneyColor};
    margin: 0.5rem 0 1rem 0;
`;

export const BalanceValuePrimaryBox = styledByTheme(BalanceValuePrimaryDefaultBox)
    .apply()
